import { notification } from 'antd'

import CloneQuoteProgress from './CloneQuoteProgress'

const ERROR_NOTIFICATION_DURATION = 5
const LOADING_NOTIFICATION_DURATION = 90
const NOTIFICATION_KEY = 'reorder-notification'

export function ReorderFailedNotification() {
    notification.open({
        message:
            'We are sorry, we ran into an issue while copying your quote. Please proceed via the chat window.',
        description: '',
        key: NOTIFICATION_KEY,
        duration: ERROR_NOTIFICATION_DURATION,
    })
}

export function LoadingNotification(enabled: boolean) {
    if (enabled) {
        return notification.open({
            message: 'Retrieving original quote information...',
            description: '',
            key: NOTIFICATION_KEY,
            duration: LOADING_NOTIFICATION_DURATION,
        })
    }

    return notification.close(NOTIFICATION_KEY)
}

const PROGRESS_BAR_NOTIFICATION_DURATION = 5

export function OpenCloneQuoteProgressNotification(
    onCloseNotification: () => void,
) {
    notification.open({
        message: 'Creating a copy of your original quote…',
        description: <CloneQuoteProgress />,
        duration: PROGRESS_BAR_NOTIFICATION_DURATION,
        onClose: onCloseNotification,
        key: NOTIFICATION_KEY,
    })
}
